"use client";

import styles from "./styles.module.css";
import Button from "@components/atoms/Button";
import H1 from "@components/atoms/H1";
import BannerBackgroundHome from "@components/molecules/BannerBackgroundHome";
import BannerContent from "@components/molecules/BannerContent";

export default function ContactBanner({section}: {section: any}) {
  const redirectButton = (page: string) => {
    window.open(page, "_blank");
  };

  return (
    <section className={`${styles.banner} ${styles["banner--sizes"]}`}>
      <BannerContent style={styles.banner__content}>
        <H1
          translation={"contact"}
          text={"contactTitle"}
          style={styles.banner__h1}
        />
        <div className={styles["buttons-container"]}>
          <Button
            translation={"contact.contactButtons"}
            text={"bookFreeSeat"}
            onClickEvent={() =>
              redirectButton("https://calendly.com/webit-factory/15minutes-free")
            }
            style={styles["buttons-container-spacer"]}
          />
          <Button
            translation={"contact.contactButtons"}
            text={"bookPaidSeat"}
            onClickEvent={() =>
              redirectButton(
                "https://calendly.com/webit-factory/2-hours-paid-consultancy-call"
              )
            }
          />
        </div>
      </BannerContent>
      <BannerBackgroundHome section={section} />
    </section>
  );
}
